/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { EnvironmentService } from './app/shared/services/environment.service';
import { Environment } from './environments/environment';
import '@angular/compiler';

const environmentService = new EnvironmentService();
const environment = new Environment(environmentService);

environment
  .init()
  .then(async () => {
    if (environment.production) {
      enableProdMode();
    }

    const { AppComponent } = await import('./app/app.component');
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  })
  .catch((error) => {
    console.error('Failed to initialize environment:', error);
  });
